<h4 class="report-title">{{ type }}</h4>

<div class="search-wrapper">
    <mat-form-field style="width: auto; margin: 10px 15px; position: absolute; right: 15px; top: 0">
        <input
            matInput
            type="text"
            placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
            autocomplete="off"
            [(ngModel)]="searchText"
            (keyup)="searchResult($event)"
        />
        <button mat-button matPrefix mat-icon-button class="search_btn">
            <mat-icon class="serach_icon">search</mat-icon>
        </button>
    </mat-form-field>
</div>

<!-- <div class="d-flex justify-content-end" *ngIf="type === 'Custom Reports'">
    <a class="btn font-weight-bold py-3 px-6 primary-ebtn" aria-haspopup="true" aria-expanded="false" (click)="addReport()">
        <span>{{ 'IDMS.REPORTS.ADD' | transloco }}</span>
    </a>
</div> -->

<div class="report_box">
    <div class="row">
        <ng-container>
            <div class="col-md-12 mb-5" *ngFor="let report of reportData; let i = index">
                <div class="report_sec">
                    <div class="d-flex align-items-center report-main">
                        <div>
                            <i
                                *ngIf="!report.isFavourite"
                                class="fas fa-thumbtack"
                                [class.active]="false"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'IDMS.REPORTS.FAVOURITE' | transloco }}"
                                matTooltipPosition="above"
                                (click)="SetFavourite(report)"
                                style="transform: rotate(45deg)"
                            ></i>
                            <i
                                *ngIf="report.isFavourite"
                                class="fas fa-thumbtack normal"
                                [class.active]="false"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'IDMS.REPORTS.UNFAVOURITE' | transloco }}"
                                matTooltipPosition="above"
                                (click)="SetFavourite(report)"
                            ></i>
                        </div>
                        <div><i class="mdi mdi-file-table" style="font-size: 26px"></i></div>
                        <div class="report-body">
                            <strong>{{ report.name }}</strong>
                            <span *ngIf="report.isScheduled">{{ 'IDMS.REPORTS.SCHEDULED' | transloco }}</span>
                        </div>
                    </div>
                    <div class="iconsec">
                        <!-- *ngIf="report.isScheduled" -->
                        <a href="javascript:void(0)" *ngIf="addSubscription && report.canSubscribe">
                            <i
                                class="far fa-calendar-alt"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'IDMS.REPORTS.SCHEDULE_REPORT' | transloco }}"
                                matTooltipPosition="above"
                                (click)="scheduleReport(report)"
                            ></i>
                        </a>
                        <a
                            *ngIf="report.onDemand"
                            href="javascript:void(0)"
                            #tooltip="matTooltip"
                            matTooltip="{{ 'IDMS.REPORTS.VIEW_REPORT' | transloco }}"
                            matTooltipPosition="above"
                            (click)="reportView(report)"
                        >
                            <i class="fas fa-eye"></i>
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="reportData?.length === 0" class="d-flex align-items-center justify-content-center w-100 h-100">
        <p class="no-data-report">{{ 'IDMS.REPORTS.NO_REPORTS_ARE_AVAILABLE_TO_DISPLAY' | transloco }}</p>
    </div>
</div>
